export default  {
  notificationContainer: {
    fontSize: "14px",
    boxSizing: "border-box",
    position: "fixed",
    zIndex: "999999"
  },
  topRight: {
    top: "26px",
    right: "9px",
    transition: "transform .6s ease-in-out",
    animation: "toast-in-right .7s"
  },
  // bottomRight: {
  //   bottom: "12px",
  //   right: "12px",
  //   transition: "transform .6s ease-in-out",
  //   animation: "toast-in-right .7s"
  // },
  // topLeft: {
  //   top: "12px",
  //   left: "12px",
  //   transition: "transform .6s ease-in",
  //   animation: "toast-in-left .7s"
  // },
  // bottomLeft: {
  //   bottom: "12px",
  //   left: "12px",
  //   transition: "transform .6s ease-in",
  //   animation: "toast-in-left .7s"
  // },
  notification: {
    background: "#fff",
    transition: ".3s ease",
    position: "relative",
    pointerEvents: "auto",
    overflow: "hidden",
    margin: "0 0 6px",
    padding: "30px",
    marginBottom: "15px",
    width: "300px",
    maxHeight: "100px",
    borderRadius: "3px 3px 3px 3px",
    boxShadow: "0 0 10px #999",
    color: "#000",
    opacity: ".9",
    backgroundPosition: "15px",
    backgroundRepeat: "no-repeat"
  },
  // ".notification:hover": {
  //   boxShadow: "0 0 12px #fff",
  //   opacity: "1",
  //   cursor: "pointer"
  // },
  notificationTitle: {
    fontWeight: "700",
    fontSize: "16px",
    textAlign: "left",
    marginTop: "0",
    marginBottom: "6px",
    width: "300px",
    height: "18px"
  },
  notificationMessage: {
    margin: "0",
    textAlign: "left",
    height: "18px",
    marginLeft: "-1px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  notificationImage: { cssFloat: "left", marginRight: "10px", marginTop: '5px' },
  notificationImageImg: { width: "30px", height: "30px" },
  toast: {
    height: "50px",
    width: "365px",
    color: "#fff",
    padding: "5px 15px 5px 10px"
  },
  notificationContainerButton: {
    position: "absolute",
    right: ".3em",
    top: ".3em",
    cssFloat: "right",
    fontWeight: "700",
    color: "#fff",
    outline: "none",
    border: ["none", "0"],
    textShadow: "0 1px 0 #fff",
    opacity: ".8",
    lineHeight: "1",
    fontSize: "16px",
    padding: "0",
    cursor: "pointer",
    background: "0 0",
    border: 'none',
  },
  }
  